export { default } from './FavoritesBlock';
